const extractErrorBodyMessage = (errorBody) => {
  if (typeof errorBody === "string") {
    const trimmedBody = errorBody.trim();
    if (!trimmedBody) {
      return null;
    }

    try {
      const parsed = JSON.parse(trimmedBody);
      return typeof parsed?.message === "string" ? parsed.message : trimmedBody;
    } catch (_) {
      return trimmedBody;
    }
  }

  if (errorBody && typeof errorBody === "object" && typeof errorBody.message === "string") {
    return errorBody.message;
  }

  return null;
};

export const buildBandErrorMessage = (t, error, fallbackKey, options = {}) => {
  const {
    conflictKey = "home.bandTab.errors.duplicateMember",
    forbiddenKey = "home.bandTab.errors.forbidden",
    notFoundKey = "home.bandTab.errors.notFound",
    capacityKey = "home.bandTab.errors.capacity",
  } = options;

  const status = error?.status ?? error?.response?.status;
  const body = extractErrorBodyMessage(error?.body)
    || (typeof error?.response?.data?.message === "string" ? error.response.data.message : null);

  if (status === 409 && conflictKey) {
    return t(conflictKey);
  }

  if (status === 403 && forbiddenKey) {
    return t(forbiddenKey);
  }

  if (status === 404 && notFoundKey) {
    return t(notFoundKey);
  }

  if (status === 400 && typeof body === "string" && /limit/i.test(body) && capacityKey) {
    return t(capacityKey);
  }

  return t(fallbackKey);
};

export default buildBandErrorMessage;
